"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _Icons = _interopRequireDefault(require("../Icons"));

var _withTheme = require("../../wrappers/with-theme");

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var to = _ref.to,
      icon = _ref.icon,
      customTheme = _ref.customTheme,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'side' : _ref$type;
  var theme = Object.assign({}, (0, _withTheme.useTheme)(), customTheme),
      linkClasses = type === 'side' ? theme.navitemSide : theme.navitemTop,
      activeClasses = type === 'side' ? theme.navitemSideActive : theme.navitemTopActive;
  var isActive = Boolean((0, _reactRouterDom.useRouteMatch)((0, _lodash["default"])(to, "pathname", to))),
      navClass = isActive ? activeClasses : linkClasses;
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: to,
    className: "".concat(className, " ").concat(navClass)
  }, icon ? /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    icon: icon,
    className: theme.menuIcon,
    showBlank: type === "side"
  }) : '', children);
};

exports["default"] = _default;